import dayjs from 'dayjs'
import { DiscountModifier, DiscountType } from '../api/api'
import { useCreateCustomerDiscount } from '../api/queries'
import type { CreateCustomerDiscountPlugin, CreateCustomerDiscountPluginComponentProps } from '../components/CreateCustomerDiscountDialog'
import { FlatDiscountComponent, type FlatDiscountForm } from '../discounts/flat'

interface FlatDiscountFactoryProps extends CreateCustomerDiscountPluginComponentProps {}

export const FlatDiscountFactory = (props: FlatDiscountFactoryProps) => {
  const { mutate: createCustomerDiscount, isLoading } = useCreateCustomerDiscount(props.customerId)

  const handleCreateFlatDiscount = (data: FlatDiscountForm) => {
    switch (data.discountModifier) {
      case DiscountModifier.PERCENTAGE: {
        return createCustomerDiscount(
          {
            billableId: props.productId,
            discountType: {
              type: DiscountType.FlatDiscount,
              modifier: data.discountModifier,
              percentageValue: data.discountValue,
            },
            expirationDate: data.expirationDate ? dayjs(data.expirationDate).format('YYYY-MM-DD') : undefined,
          },
          { onSuccess: () => props.onCreatedDiscount() },
        )
      }

      case DiscountModifier.ABSOLUTE: {
        return createCustomerDiscount(
          {
            billableId: props.productId,
            discountType: {
              type: DiscountType.FlatDiscount,
              modifier: data.discountModifier,
              absoluteAmount: {
                value: data.discountValue,
                currency: props.currency,
              },
            },
            expirationDate: data.expirationDate ? dayjs(data.expirationDate).format('YYYY-MM-DD') : undefined,
          },
          { onSuccess: () => props.onCreatedDiscount() },
        )
      }
    }
  }

  return <FlatDiscountComponent isPatching={isLoading} currency={props.currency} onCreateFlatDiscount={handleCreateFlatDiscount} />
}

export class FlatDiscountPlugin implements CreateCustomerDiscountPlugin {
  name: string = 'Flat'
  getComponent() {
    return FlatDiscountFactory
  }
  supports(discountType: string) {
    return discountType === 'Flat'
  }
}
